module.exports = __webpack_public_path__ + "static/media/best_workplace_badge_7.5c8d6c07.png";